import React from 'react';
import { Lightbulb } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-slate-900 text-slate-300 py-24 px-4 relative overflow-hidden" data-id="element-129">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-900/10 blur-[100px] pointer-events-none" data-id="element-130"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-131">
        <div className="flex justify-center mb-12" data-id="element-132">
          <div className="w-20 h-20 bg-amber-500/20 rounded-full flex items-center justify-center border border-amber-500/30" data-id="element-133">
            <Lightbulb className="w-10 h-10 text-amber-400" data-id="element-134" />
          </div>
        </div>

        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-center mb-16" data-id="element-135">
          <p className="font-bold text-2xl text-white" data-id="element-136">
            ¿Y si el problema no fuera tu hernia?
          </p>
          <p className="font-bold text-2xl text-white" data-id="element-137">
            ¿Y si no fuera tu edad?
          </p>
          <p className="font-bold text-2xl text-white" data-id="element-138">
            ¿Y si no fuera tu espalda?
          </p>

          <p className="text-3xl md:text-4xl font-extrabold text-orange-400 mt-8" data-id="element-139">
            ¿Y si fuera simplemente… el ángulo?
          </p>
        </div>

        <div className="bg-slate-800/80 border border-slate-700 p-8 md:p-10 rounded-2xl shadow-2xl mb-16" data-id="element-140">
          <p className="text-slate-400 mb-6 font-semibold uppercase tracking-wider text-sm" data-id="element-141">
            Esto es lo que descubrimos:
          </p>
          <blockquote className="text-2xl md:text-3xl font-bold text-white leading-snug border-l-4 border-blue-500 pl-6" data-id="element-142">
            "El nervio ciático no se 'inflama solo'. Se irrita porque algo lo
            aplasta. Y ese algo — la posición incorrecta en el momento de mayor
            vulnerabilidad — es{' '}
            <span className="text-green-400" data-id="element-143">completamente controlable.</span>"
          </blockquote>
        </div>

        <div className="text-center mb-12" data-id="element-144">
          <p className="text-xl text-slate-400 font-bold uppercase tracking-widest mb-4" data-id="element-145">
            Aquí entra el método
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-12" data-id="element-146">
            El Método de Descompresión en{' '}
            <span className="text-blue-400" data-id="element-147">Ángulo Neutro</span>
          </h2>
        </div>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-148">
          <p data-id="element-149">Este protocolo no es una rutina de ejercicios.</p>
          <p data-id="element-150">
            No necesitas colchoneta, ni bandas elásticas, ni ir al gimnasio.
          </p>
          <p data-id="element-151">No requiere que seas flexible.</p>

          <p className="font-extrabold text-2xl text-white py-6 text-center" data-id="element-152">
            Es ingeniería corporal aplicada al momento exacto.
          </p>

          <p className="font-bold text-white" data-id="element-153">Funciona así:</p>

          <p data-id="element-154">
            Mientras todavía estás en el colchón — antes de que la gravedad
            vertical actúe sobre tus discos — realizas una secuencia de{' '}
            <strong className="text-orange-400" data-id="element-155">
              micro-movimientos de 7 minutos
            </strong>{' '}
            que:
          </p>

          <div className="space-y-6 py-8" data-id="element-156">
            <div className="flex gap-4 items-start bg-slate-800/50 p-6 rounded-xl border border-slate-700/50" data-id="element-157">
              <div className="w-10 h-10 rounded-full bg-blue-500/20 text-blue-400 font-bold flex items-center justify-center flex-shrink-0 text-xl" data-id="element-158">
                1
              </div>
              <p data-id="element-159">
                <strong className="text-white" data-id="element-160">
                  Relajan los músculos lumbares y pélvicos
                </strong>{' '}
                que comprimían el nervio durante la noche
              </p>
            </div>

            <div className="flex gap-4 items-start bg-slate-800/50 p-6 rounded-xl border border-slate-700/50" data-id="element-161">
              <div className="w-10 h-10 rounded-full bg-blue-500/20 text-blue-400 font-bold flex items-center justify-center flex-shrink-0 text-xl" data-id="element-162">
                2
              </div>
              <p data-id="element-163">
                <strong className="text-white" data-id="element-164">
                  Crean espacio entre vértebras
                </strong>{' '}
                usando la posición horizontal + gravedad controlada
              </p>
            </div>

            <div className="flex gap-4 items-start bg-slate-800/50 p-6 rounded-xl border border-slate-700/50" data-id="element-165">
              <div className="w-10 h-10 rounded-full bg-blue-500/20 text-blue-400 font-bold flex items-center justify-center flex-shrink-0 text-xl" data-id="element-166">
                3
              </div>
              <p data-id="element-167">
                <strong className="text-white" data-id="element-168">Preparan el disco</strong> para
                absorber el impacto cuando finalmente te pongas de pie
              </p>
            </div>
          </div>

          <div className="bg-green-900/20 border border-green-500/30 p-8 rounded-2xl text-center mt-8" data-id="element-169">
            <p className="text-green-400 font-bold text-xl mb-4 uppercase tracking-wider" data-id="element-170">
              El resultado:
            </p>
            <p className="text-2xl md:text-3xl font-extrabold text-white" data-id="element-171">
              Cuando tus pies tocan el suelo, el nervio ya no está en su punto
              de máxima presión.
            </p>
            <p className="text-3xl md:text-4xl font-extrabold text-orange-400 mt-6" data-id="element-172">
              El latigazo no tiene donde atacar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}